import "regenerator-runtime/runtime";
import "cross-fetch/polyfill";
import "core-js/es/array/find"; // included for react-final-form and react-datetime on IE
import configureSentry from "./utils/staticPages/configureSentry";

configureSentry();
require("./browserRender");
